import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle, Clock } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-white py-20 md:py-28 px-6" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-149">
            <AlertTriangle className="w-8 h-8 text-amber" data-id="element-150" />
            <h2 className="text-3xl md:text-4xl font-serif text-slate-900 text-center" data-id="element-151">
              ¿Por Qué Esto Es Tan Difícil?
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-12" data-id="element-152">
          <FadeIn delay={0.2} data-id="element-153">
            <div className="space-y-6 text-lg text-slate-700" data-id="element-154">
              <p data-id="element-155">
                La ansiedad adolescente en USA ha alcanzado niveles récord. Como
                padre, ver a tu hijo sufrir un ataque de pánico es una de las
                experiencias más impotentes del mundo.
              </p>
              <p data-id="element-156">
                Sientes que el aire se acaba en la habitación y el miedo a que
                sea algo grave (como un infarto) te paraliza a ti también.
              </p>
              <p data-id="element-157">
                La mayoría de los consejos en internet son demasiado lentos o
                demasiado técnicos. Tu hijo no necesita una terapia de una hora
                cuando siente que se está desmayando...
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-158">
            <div className="bg-slate-900 rounded-2xl p-8 text-center shadow-xl relative overflow-hidden" data-id="element-159">
              <div className="absolute top-0 right-0 w-32 h-32 bg-sage opacity-10 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-160"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-amber opacity-10 rounded-full blur-3xl -ml-10 -mb-10" data-id="element-161"></div>

              <Clock className="w-12 h-12 text-amber mx-auto mb-4" data-id="element-162" />
              <h3 className="text-white text-xl mb-2 font-medium" data-id="element-163">
                Necesita una solución que funcione en los próximos
              </h3>
              <div className="text-6xl md:text-7xl font-serif text-amber font-bold my-4" data-id="element-164">
                300
              </div>
              <p className="text-sage-light text-2xl font-serif tracking-wide uppercase" data-id="element-165">
                Segundos
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}